import NotSoImportantNews from "./NotSoImportantNews";

export default NotSoImportantNews;